// Statuses that make an order ineligible for transfer out
export const INELIGIBLE_TRANSFER_OUT_STATUSES = [
  'CANCELED',
  'SHIPPED',
  'EXPIRED',
  'IN_SHIPMENT',
  'READY_FOR_SHIPMENT',
  'ORDER_VERIFIED',
];

// Statuses that disable transfer out option (includes TRANSFERRED)
export const DISABLED_TRANSFER_OUT_STATUSES = [
  'CANCELED',
  'SHIPPED',
  'TRANSFERRED',
  'IN_SHIPMENT',
  'READY_FOR_SHIPMENT',
  'ORDER_VERIFIED',
];

// Statuses that disable tags option
export const DISABLED_TAGS_STATUSES = ['SHIPPED', 'CANCELED', 'TRANSFERRED', 'EXPIRED'];
// Statuses for order history filtering (completed/closed orders)
export const ORDER_HISTORY_STATUSES = [
  'CANCELED',
  'SHIPPED',
  'EXPIRED',
  'TRANSFERRED',
  'FILL_LATER',
];

// Statuses for basic order history (without EXPIRED and TRANSFERRED).
// POM-6219: this drives Ship Later, Send Order Back To Queue, Void Shipment and the reshipment
// refresh flows - it is NOT the Order History list. FILL_LATER must never be added here, or those
// actions would start operating on parked orders.
export const BASIC_ORDER_HISTORY_STATUSES = ['CANCELED', 'SHIPPED'];
